// src/components/orderentry/panels/SpecialOrderDialog.jsx
// -----------------------------------------------------------------------------
// SPECIAL ORDER POPUP
//
// Responsibilities:
//  - Simple modal dialog showing the "special order" note content
//  - Controlled by the parent (OrderEntry.jsx) via open + onClose
// -----------------------------------------------------------------------------

import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

export default function SpecialOrderDialog({ open, note, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Special Order</DialogTitle>

      <DialogContent dividers>
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
          {note || '—'}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
